// extracted by mini-css-extract-plugin
export var container = "_72-0";
export var error = "_72-9";
export var label = "_72-5";
export var light = "_72-6";
export var md = "_72-3";
export var sm = "_72-2";
export var thin = "_72-8";
export var thinBold = "_72-7";
export var vertical = "_72-4";
export var xs = "_72-1";